// extracted by mini-css-extract-plugin
module.exports = {"editor":"KRichText_editor__JBngb","tooltip":"KRichText_tooltip__1WINY"};